export default "__VITE_ASSET__DYkraeZO__"